export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download PDF"])},
        "share": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Share"])},
        "edit_album_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit album name"])},
        "no_objects_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No starred objects"])},
        "no_objects_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your album is empty. Use the star button to add objects to your album."])}
      },
      "de": {
        "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download PDF"])},
        "share": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teilen"])},
        "edit_album_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Albumnamen bearbeiten"])},
        "no_objects_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Objekte"])},
        "no_objects_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ihr Album ist leer. Benutzen Sie den Stern-Button um Objekte in Ihr Album hinzuzufügen."])}
      }
    }
  })
}
